import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class NoteColumn extends Column {
    title = 'time-tracking.timesheetsIndexPage.table.note';
    property = 'note';
    type: CellDisplay = CellDisplay.string;
}
